/* eslint-disable react/display-name */
import React from "react";
import PropTypes from "prop-types";
import Toggle from "react-toggle";
import ReactTable from "react-table";
import matchSorter, { rankings } from "match-sorter";

import Loading from "../common/Loading";

import TableActions from "../common/TableActions";
import Avatar from "../styled/Avatar";

const UserList = ({
  users,
  search,
  onToggle,
  onClickView,
  onClickDelete,
  isMobile,
  loading
}) => {
  const columns = [
    {
      accessor: "avatar",
      maxWidth: 80,
      sortable: false,
      Cell: ({ original, value }) => <Avatar user={original} avatar={value} />
    },
    {
      Header: "Status",
      accessor: "is_active",
      filterable: false,
      maxWidth: 100,
      Cell: (row) => (
        <Toggle
          onChange={() => onToggle(row.original)}
          checked={row.value}
          value={row.value.toString()}
        />
      )
    },
    { Header: "First Name", accessor: "first_name" },
    { Header: "Last Name", accessor: "last_name" },
    { Header: "Tech Id", accessor: "tech_id" },
    { Header: "Email", accessor: "email" },
    { Header: "Department", accessor: "department.description" },
    {
      Header: "Manager",
      accessor: "manager.full_name",
      Cell: ({ value }) => value || "--"
    },
    {
      Header: "Role(s)",
      accessor: "roles",
      Cell: (row) => {
        const roles = row.original.roles.map((role) => role.name);
        return roles.join(", ");
      }
    },
    {
      Header: "",
      accessor: "_id",
      maxWidth: 80,
      filterable: false,
      Cell: (row) => (
        <TableActions
          onClickView={() => onClickView(row.value)}
          onClickDelete={() => onClickDelete(row.value)}
        />
      )
    }
  ];

  const usersToUse =
    search && search.length
      ? matchSorter(users, search, {
          keys: [
            { threshold: rankings.STARTS_WITH, key: "first_name" },
            { threshold: rankings.STARTS_WITH, key: "last_name" },
            { minRanking: rankings.STARTS_WITH, key: "job_title" },
            { threshold: rankings.STARTS_WITH, key: "department.description" },
            { threshold: rankings.STARTS_WITH, key: "manager.full_name" }
          ]
        })
      : users;

  const props = {
    getTdProps: (state, rowInfo, column) => ({
      onClick: () => {
        if (
          column.id !== "_id" &&
          column.id !== "is_active" &&
          rowInfo?.original?._id
        ) {
          onClickView(rowInfo.original._id);
        }
      }
    })
  };

  const isLoading = !usersToUse.length;

  if (loading || isLoading) {
    return (
      <div className="flex -center -full">
        <Loading active />
      </div>
    );
  }

  return (
    <ReactTable
      className="-highlight"
      data={usersToUse}
      loading={isLoading || loading}
      LoadingComponent={() => <Loading active={isLoading} />}
      columns={columns}
      showPageSizeOptions={!isMobile}
      defaultPageSize={10}
      {...props}
      defaultSorted={[
        {
          id: "first_name",
          asc: true
        }
      ]}
    />
  );
};

UserList.propTypes = {
  users: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      full_name: PropTypes.string.isRequired,
      first_name: PropTypes.string.isRequired,
      last_name: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
      createdAt: PropTypes.string
    }).isRequired
  ).isRequired,
  filter: PropTypes.object,
  onChange: PropTypes.func,
  onClickView: PropTypes.func.isRequired,
  onClickDelete: PropTypes.func.isRequired,
  search: PropTypes.string,
  onToggle: PropTypes.func,
  isMobile: PropTypes.bool,
  original: PropTypes.func,
  value: PropTypes.any,
  loading: PropTypes.bool
};

export default UserList;
